export const interiorView10ImageOptions = {
	angle:"InteriorView10",
	staticOptions:{
		PortAftCabinOptions:1,
		StarboardAftCabinOptions:1,
		Veneer:1,
		Floorboard:1,
		StarboardAftCabin:1,
		FabricSaloon:1,
		CupboardsOwnersCabin:1,
		Mast:1,
		TableBox:1,
		Pouffes:1,
		FabricCabins:1,
	},
	mattes:[
		{
			option:"PortAftCabinOptions",
			dependency:"Veneer"
		},
		{
			option:"Veneer",
			dependency:null
		},
		{
			option:"Floorboard",
			dependency:"Pouffes"
		},
		{
			option:"StarboardAftCabin",
			dependency:null
		},
		{
			option:"FabricSaloon",
			dependency:"StarboardAftCabin"
		},
		{
			option:"CupboardsOwnersCabin",
			dependency:"Veneer"
		},
		{
			option:"TableBox",
			dependency:"Veneer"
		},
		{
			option:"Pouffes",
			dependency:["Veneer", "FabricSaloon"]
		},
		{
			option:"FabricCabins",
			dependency:null
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/InteriorView10.js